import { MapLayerModel } from "./MapLayer.model";

export class MapLayer extends MapLayerModel {
    // Add custom methods here
}
